import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { Dimmer, Loader } from "semantic-ui-react";

export const MyOrgInvoices = (props) => {
  const [subscriptionData, setSubscriptionData] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    console.info(`component loaded.`);
    (async () => {
      await loadSubscriptionInfo();
    })();
    return () => {
      console.info(`component unloaded.`);
    };
  }, []);

  const loadSubscriptionInfo = async () => {
    console.info(`loading subscription...`);

    setLoading(true);

    const baseURL = process.env.NODE_ENV === "production" ? process.env.REACT_APP_API_HOST_URL : "http://localhost:8080";
    const accessToken = localStorage.getItem("accessToken");
    const API = axios.create({baseURL, headers: { Authorization: `Bearer ${accessToken}` },});

    const response = await API.post(`/get-subscription`, {}).catch((error) => {
      console.info({ error });
      if (error.isAxiosError && error.response.data && error.response.data.status) {
        console.info(error.response.data.status);
        const { code, message } = error.response.data.status;
        console.info({ code });
        toast.error(message);
        setLoading(false);
        return error.response.data.status;
      } else {
        toast.error(`There was an error. Please try again later.`);
        setLoading(false);
      }
    });
    if (response && response.data && response.data.status) {
      const { code, message } = response.data.status;
      const subscriptionInfo = response.data.data;
      console.info({ subscriptionInfo });
      console.info({ code, message });
      toast.success(message);
      setSubscriptionData(subscriptionInfo);
      /*if (code === `organization/subscription-fetched`) */
      setLoading(false);
    }
  };

  return (
    <div className="sub-page" id="invoice-management">
      {loading && (
        <Dimmer active inverted>
          <Loader inverted>Loading</Loader>
        </Dimmer>
      )}

      <div className="ui segment">
        <h3>Active Subscription: {subscriptionData.plan}</h3>
        <hr />
        <div className="ui three column grid">
          <div className="column"><p><strong>Date started:</strong> {subscriptionData.startDate}</p></div>
          <div className="column"><p><strong>End Date:</strong> {subscriptionData.endDate}</p></div>
          <div className="column"><p><strong>Status:</strong> {subscriptionData.status}</p></div>
          {/*<div className="column"><p><strong>billingCycleDate:</strong> {subscriptionData.billingCycleDate}</p></div>*/}
          <div className="column"><p><strong>1 Unit Price:</strong> ${subscriptionData.subscriptionCharges}{" "}<strong>x number of employees:</strong>{" "}{subscriptionData.subscribedUsersCount}
            </p></div>
          <div className="column"><p><strong>Tax Rate applied:</strong>{" "}{subscriptionData.taxRate && subscriptionData.taxRate.percentage}%
              ({subscriptionData.taxRate && subscriptionData.taxRate.region})</p>
          </div>
        </div>
      </div>

      <table className="ui single line table teams">
        <thead>
          <tr>
            <th>Status</th>
            <th>Total</th>
            <th>Invoice Number</th>
            <th>Paid By</th>
            <th>Received At</th>
          </tr>
        </thead>
        <tbody>
          {subscriptionData.invoices && subscriptionData.invoices.length && subscriptionData.invoices.map((invoice) => {
              const invoicePaymentStatus = `${invoice.paid ? "paid" : "unpaid"}`;
              return (<tr key={invoice.id}>
                  <td><label className={`invoice-filter-btn unpaid yellow ${invoicePaymentStatus}`}>{invoicePaymentStatus}</label></td>
                  <td>${invoice.total}</td>
                  <td><a href={invoice.pdf} download><i className="icon download" /> {invoice.number}</a></td>
                  <td>{invoice.customerEmail}</td>
                  <td>{invoice.startDate}</td>
                </tr>);
            })}
        </tbody>
      </table>
    </div>
  );
};
